import { render, staticRenderFns } from "./PCR_upload.vue?vue&type=template&id=188ed566&scoped=true&"
import script from "./PCR_upload.vue?vue&type=script&lang=js&"
export * from "./PCR_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ed566",
  null
  
)

export default component.exports